/**
 * Convert slug to readable text
 */

export default function deparameterize(str) {
  if (!str) return '';
  return str.replace(/-/g, ' ');
}
